import React from "react";
import "./LoadingOverlay.css";

interface LoadingOverlayProps {
  isVisible: boolean;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isVisible,
}) => {
  if (!isVisible) return null;

  return (
    <div className="loading-overlay">
      <div className="loading-content">
        <img
          src="/images/bitcoin.png"
          alt="Loading"
          className="btc-spinner"
        />
        <p>Loading data...</p>
      </div>
    </div>
  );
};

export default LoadingOverlay;
